
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon awesome-user-edit","d":"M22.4 32A12.8 12.8 0 109.6 19.2 12.8 12.8 0 0022.4 32zm9 3.2h-1.71a17.43 17.43 0 01-14.58 0h-1.67A13.44 13.44 0 000 48.64v4.16a4.8 4.8 0 004.8 4.8h27.49a5 5 0 01-.29-2.13l.68-6.08.13-1.11.79-.79 7.73-7.73a13.32 13.32 0 00-9.97-4.56zm4.53 14.53l-.69 6.1a1.6 1.6 0 001.42 1.76H37l6-.68 13.83-13.79L49.68 36zM63.3 33.28l-3.78-3.78a2.4 2.4 0 00-3.38 0l-3.79 3.78-.41.41 7.18 7.17 4.18-4.18a2.41 2.41 0 000-3.39z"}})])
          )
        }
      }
    